// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"SendNotePage_checkbox__T6HD4","navButtons":"SendNotePage_navButtons__ZRIxw","previousMessagesContainer":"SendNotePage_previousMessagesContainer__Jb1dj"};